export default __webpack_public_path__ + "static/media/logo_ics.d1209df6.png";